import s from "./basket.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setMethods} from "../../store/OrdersHistorySlice";
import {setUserInfo} from "../../firebase";
import {NavLink} from "react-router-dom";


const OrderCheckout = () => {

    const [deliveryMethod, setDeliveryMethod] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const dispatch = useDispatch();
    const userId = useSelector(state => state.authUser.userId);
    const orders = useSelector(state => state.setHistory.orders);


    const handleSubmit = () => {
        dispatch(setMethods({deliveryMethod, paymentMethod}));
        setUserInfo(userId, {OrdersHistory: orders});
        setUserInfo(userId, {deliveryMethod, paymentMethod})
    }

    return (
        <div className={s.basket}>
            <div className={`${s.basketContent} content`}>
                <Breadcrumbs/>
                <h3>Выберите метод доставки:</h3>
                <form className={s.checkout}>
                    <div>
                        <label><input type="radio" name="subscribe" onClick={(e) => setDeliveryMethod(e.target.value)}
                                      value="Новая почта"/><span>Новая почта</span></label>
                    </div>
                    <div>
                        <label><input type="radio" name="subscribe" onClick={(e) => setDeliveryMethod(e.target.value)}
                                      value="Укр почта"/><span>Укр почта</span></label>
                    </div>
                    <div>
                        <label> <input type="radio" name="subscribe" onClick={(e) => setDeliveryMethod(e.target.value)}
                                       value="Мист экспресс"/><span>Мист экспресс</span></label>
                    </div>
                    <div>
                        <label> <input type="radio" name="subscribe" onClick={(e) => setDeliveryMethod(e.target.value)}
                                       value="Самовывоз"/><span>Самовывоз</span></label>
                    </div>
                </form>
                <h3>Выберите метод оплаты:</h3>
                <form className={s.checkout}>
                    <div>
                        <label><input onClick={(e) => setPaymentMethod(e.target.value)} type="radio" name="subscribe"
                                      value="Наложенный платеж"/><span>Наложенный платеж</span></label>
                    </div>
                    <div>
                        <label><input onClick={(e) => setPaymentMethod(e.target.value)} type="radio" name="subscribe"
                                      value="Visa/MasterCard"/><span>Visa/MasterCard</span></label>
                    </div>
                </form>
                <NavLink to="/basket/success"><BuyButton onClick={() => handleSubmit()}>Оформить</BuyButton></NavLink>
            </div>
        </div>

    )
}

export default OrderCheckout;